export default (vendors, searchTerm, statusFilter) => {
  const normalizedSearchTerm = searchTerm ? searchTerm.toUpperCase() : "";

  const filteredVendors = vendors.filter((vendor) => {
    if (statusFilter !== "All" && vendor.status !== statusFilter) {
      return false;
    }

    if (!normalizedSearchTerm) {
      return true;
    }

    const searchableFields = [
      vendor.vendorNum,
      vendor.name,
      vendor.description,
      vendor.serviceTerritory,
      vendor.contactName,
      vendor.contactPhone,
      vendor.contactEmail,
      vendor.status,
    ];

    return searchableFields.some((field) => {
      return String(field || "")
        .toUpperCase()
        .includes(normalizedSearchTerm);
    });
  });

  return { items: filteredVendors };
};
